import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getIdToken } from '../firebase';

function ManageApplications() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchApplications = async () => {
    try {
      const token = await getIdToken();
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/tutor-applications`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setApplications(res.data);
    } catch (error) {
      console.error('Failed to fetch applications:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleAction = async (id, action) => {
    try {
      const token = await getIdToken();
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/tutor-applications/${id}/${action}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchApplications(); // refresh list
    } catch (error) {
      console.error(`Failed to ${action} application:`, error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div>
      <h2>Manage Applications</h2>
      {applications.length === 0 ? (
        <p>No tutor applications found.</p>
      ) : (
        applications.map(app => (
          <div key={app.id} style={{ border: '1px solid #ccc', marginBottom: '1rem', padding: '1rem' }}>
            <h4>{app.applicant.username} ({app.applicant.email})</h4>
            <p>Applied on: {new Date(app.appliedAt).toLocaleString()}</p>
            <p>Status: <strong>{app.status || 'pending'}</strong></p>
            <ul>
                {app.courses.map((c, idx) => (
                  <li key={idx}>
                    {c.title} — Online: R{c.onlinePrice} | Face-to-Face: R{c.faceTofacePrice}
                  </li>
                ))}
              </ul>

              {/* Document download links */}
              {app.transcriptURL && (
                <p>
                  <a href={app.transcriptURL} target="_blank" rel="noopener noreferrer">
                    📄 View Transcript
                  </a>
                </p>
              )}
              {app.idCopyURL && (
                <p>
                  <a href={app.idCopyURL} target="_blank" rel="noopener noreferrer">
                    🪪 View ID Copy
                  </a>
                </p>
              )}



            {(!app.status || app.status === 'pending') && (
              <div style={{ marginTop: '1rem' }}>
                <button onClick={() => handleAction(app.id, 'approve')} style={{ marginRight: '1rem' }}>
                  Approve
                </button>
                <button onClick={() => handleAction(app.id, 'reject')} style={{ color: 'red' }}>
                  Reject
                </button>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default ManageApplications;
